import adapter from './adapter';

export default {
    fetching(state, payload) {
        state.collection = adapter.upsertOne(payload, state.collection)
    },
    fetched(state, payload) {
        state.collection = adapter.removeOne(payload, state.collection)
    }
}
